// extracted by mini-css-extract-plugin
export var container = "_eo-0";
export var icon = "_eo-1";
export var text = "_eo-2";